export default __webpack_public_path__ + "static/Blind-angels-zakia-video-thumbnail-21be9cb43c6aa0a5bc6317f328d673b4.png";